import React, { useState } from "react";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";

// 固定方法接口
export interface DialogMethods {
    open?: () => void;
    close?: () => void;
}

export const useDialogMethods = (key:string,callbacks?:DialogMethods) => {
    const [isOpen, setIsOpen] = useState(true);
    const [fcKey, setFcKey] = useState(key);
    const [isOk, setIsOK] = useState(false);


    const openDialog = () => {
        console.log("Opening dialog...",fcKey);
        setIsOpen(true);
        if (callbacks){
            callbacks.open;
        }
    };

    const closeDialog = () => {
        console.log("Closing dialog...",fcKey);
        setIsOpen(false);
        if(fcKey) SDialogManagerFC.closeDialog(fcKey);
        if (callbacks){
            callbacks.close;
        }
    };


    return { fcKey,isOpen, openDialog, closeDialog };
};
